import registerVimeoPlayer from '../../js/components/vimeo-playback.js';

const initializeShowcaseVideos = (root = document) => {

    const videos = root.matches?.('[data-showcase-video]')
        ? [root]
        : root.querySelectorAll('[data-showcase-video]');

    videos.forEach((video) => {

        const button = video.querySelector('[data-showcase-video-play]');
        const iframe = video.querySelector('[data-showcase-video-iframe]');

        if (!button || !iframe || button.dataset.initialized === 'true') {

            return;

        }

        button.dataset.initialized = 'true';
        const player = registerVimeoPlayer(iframe);

        button.addEventListener('click', async() => {

            const poster = video.querySelector('[data-showcase-video-poster]');

            poster?.classList.add('opacity-0');
            iframe.classList.remove('hidden');
            button.hidden = true;
            iframe.focus();

            try {

                await player.play();

            } catch {

                // The visible Vimeo controls remain available if autoplay is blocked.

            }

        });

    });

};

initializeShowcaseVideos();

if (window.acf?.addAction) {

    window.acf.addAction('render_block_preview/type=showcase-video', ($block) => {

        initializeShowcaseVideos($block[0]);

    });

}
